import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-50" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  role: "list",
  class: "grid grid-cols-1 gap-4 lg:grid-cols-3"
}
const _hoisted_4 = { class: "group col-span-1 flex shadow-sm rounded-2xl cursor-pointer" }
const _hoisted_5 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_6 = { class: "flex-shrink-0 pl-4 pr-4 flex items-center justify-center" }
const _hoisted_7 = { class: "group col-span-1 flex shadow-sm rounded-2xl cursor-pointer" }
const _hoisted_8 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_9 = { class: "flex-shrink-0 pl-4 pr-4 flex items-center justify-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-brand-secondary text-md font-medium uppercase tracking-wide" }, "Select a Voip Product", -1)
const _hoisted_12 = { class: "mt-4 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-brand-secondary text-md font-medium uppercase tracking-wide" }, "Voip Home Number Listed Or Listed?", -1)
const _hoisted_15 = {
  role: "list",
  class: "mt-4 grid grid-cols-1 gap-4 lg:grid-cols-3"
}
const _hoisted_16 = { class: "group col-span-1 flex shadow-sm rounded-2xl cursor-pointer" }
const _hoisted_17 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_18 = { class: "flex-shrink-0 pl-4 pr-4 flex items-center justify-center" }
const _hoisted_19 = { class: "group col-span-1 flex shadow-sm rounded-2xl cursor-pointer" }
const _hoisted_20 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_21 = { class: "flex-shrink-0 pl-4 pr-4 flex items-center justify-center" }
const _hoisted_22 = { class: "text-base font-extralight mt-4 p-4 border" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Your number will be set as unlisted by default but will be registered in the IPND database for emergency services. This can be changed at any time by contacting our friendly Australian-based support team on ")
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode(". More information on IPND Policy can be found ")
const _hoisted_28 = ["href"]

import { ref } from 'vue';
import VoipSelectorProduct from './VoipSelectorProduct.vue';
import { CheckCircleIcon } from '@heroicons/vue/outline';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    products: { type: Array, required: true },
    isVoipAdded: { type: Boolean, required: true },
    isVoipListed: { type: Boolean, required: true },
    selected: { type: String, required: true }
  },
  emits: ["onPlanSelected", "onVoipToggled", "onListingStatusToggled"],
  setup(__props: any, { emit }: { emit: ({(e: 'onPlanSelected', id: string): void, (e: 'onVoipToggled', isVoipAdded: boolean): void, (e: 'onListingStatusToggled', isVoipListed: boolean): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  products: Array<Product>,
  isVoipAdded: boolean,
  isVoipListed: boolean,
  selected: string
}

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const voipInformation = brandService.getVoipInformation();





const voipProductAdded = ref(false);
const voipListedNumber = ref(false);
const productSelected = ref<Product|null>();

const handleClickAddVoipProduct = () => {
  voipProductAdded.value = true;
  emit('onVoipToggled', true);
};

const handleClickRemoveVoipProduct = () => {
  voipProductAdded.value = false;
  emit('onVoipToggled', false);
};

const handleClickListedVoipProduct = () => {
  voipListedNumber.value = true;
  emit('onListingStatusToggled', true);
};

const handleClickUnlistedVoipProduct = () => {
  voipListedNumber.value = false;
  emit('onListingStatusToggled', false);
};

const handleSelectProduct = (product: Product): void => {
  productSelected.value = product;
  emit('onPlanSelected', product.id);
};

const isSelectedProduct = (product: Product): boolean => {
  return product.id === props.selected;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("div", {
            onClick: handleClickAddVoipProduct,
            class: _normalizeClass(["transition duration-250", [(voipProductAdded.value ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-xl transition duration-250 text-black", [voipProductAdded.value ? 'text-black' : 'text-black']])
              }, "Yes", 2)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["w-8 h-8 bg-white inline-flex items-center justify-center rounded-full bg-transparent", [ voipProductAdded.value ? 'text-black' : 'text-black' ]])
              }, [
                (voipProductAdded.value)
                  ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                      key: 0,
                      class: "w-8 h-8",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ], 2)
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("div", {
            onClick: handleClickRemoveVoipProduct,
            class: _normalizeClass(["transition duration-250", [(!voipProductAdded.value ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-xl transition duration-250 text-black", [ !voipProductAdded.value ? 'text-black' : 'text-black' ]])
              }, "No", 2)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["w-8 h-8 bg-white inline-flex items-center justify-center rounded-full bg-transparent", [ !voipProductAdded.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
              }, [
                (!voipProductAdded.value)
                  ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                      key: 0,
                      class: "w-8 h-8",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ], 2)
        ])
      ]),
      (voipProductAdded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product) => {
                return (_openBlock(), _createBlock(VoipSelectorProduct, {
                  onHandleSelectProduct: handleSelectProduct,
                  product: product,
                  key: product.name,
                  isSelectedProduct: isSelectedProduct(product)
                }, null, 8, ["product", "isSelectedProduct"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (voipProductAdded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("ul", _hoisted_15, [
              _createElementVNode("li", _hoisted_16, [
                _createElementVNode("div", {
                  onClick: handleClickListedVoipProduct,
                  class: _normalizeClass(["transition duration-250", [(voipListedNumber.value ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]])
                }, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-xl transition duration-250 text-black", [voipListedNumber.value ? 'text-black' : 'text-black']])
                    }, "Listed", 2)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["w-8 h-8 bg-white inline-flex items-center justify-center rounded-full bg-transparent", [ voipListedNumber.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                    }, [
                      (voipListedNumber.value)
                        ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                            key: 0,
                            class: "w-8 h-8",
                            "aria-hidden": "true"
                          }))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ], 2)
              ]),
              _createElementVNode("li", _hoisted_19, [
                _createElementVNode("div", {
                  onClick: handleClickUnlistedVoipProduct,
                  class: _normalizeClass(["transition duration-250", [(!voipListedNumber.value ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]])
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-xl transition duration-250 text-black", [ !voipListedNumber.value ? 'text-black' : 'text-bloack' ]])
                    }, "Unlisted", 2)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["w-8 h-8 bg-white inline-flex items-center justify-center rounded-full bg-transparent", [ !voipListedNumber.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                    }, [
                      (!voipListedNumber.value)
                        ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                            key: 0,
                            class: "w-8 h-8",
                            "aria-hidden": "true"
                          }))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ], 2)
              ])
            ]),
            _createElementVNode("p", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("a", {
                class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250",
                target: "_blank",
                href: 'mailto:' + _unref(voipInformation).email
              }, _toDisplayString(_unref(voipInformation).email), 9, _hoisted_24),
              _hoisted_25,
              _createElementVNode("a", {
                class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250",
                target: "_blank",
                href: 'tel:' + _unref(voipInformation).phone
              }, _toDisplayString(_unref(voipInformation).phone), 9, _hoisted_26),
              _hoisted_27,
              _createElementVNode("a", {
                href: _unref(voipInformation).csaAgreementUrl,
                target: "_blank",
                class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250"
              }, "here.", 8, _hoisted_28)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})